import notificationService from '@/services/notification-service'



export default {

  namespaced: true,

  state: {

    items: [],

    loading: false,

    apiAvailable: null,

  },

  getters: {

    items: state => state.items,

    unreadCount: state => state.items.filter(n => n && !n.read).length,

    hasUnread: state => state.items.some(n => n && !n.read),

  },

  mutations: {

    SET_ITEMS(state, items) {

      state.items = Array.isArray(items) ? items : []

    },

    SET_LOADING(state, val) {

      state.loading = !!val

    },

    SET_API_AVAILABLE(state, val) {

      state.apiAvailable = val

    },

  },

  actions: {

    /**

     * Full refresh: API list (server truth); soft-fail may yield empty /

     * session task synthesis (no persisted cache fallback).

     * Pass `tasks` when the caller already fetched assignee tasks.

     */

    async refresh({ commit }, { empId, tasks } = {}) {

      commit('SET_LOADING', true)

      try {

        const items = await notificationService.loadInbox({ empId, tasks })

        commit('SET_ITEMS', items)

        commit('SET_API_AVAILABLE', notificationService.apiAvailable)

        return items

      } finally {

        commit('SET_LOADING', false)

      }

    },



    /**

     * Sync from a polled task list (App.vue / task-ping-notifier).

     * When notifications API is up: POST missing + GET list.

     */

    async ingestTaskPings({ commit }, { empId, tasks } = {}) {

      const items = await notificationService.ingestTaskPings(empId, tasks)

      commit('SET_ITEMS', items)

      commit('SET_API_AVAILABLE', notificationService.apiAvailable)

      return items

    },



    /**

     * Sync Vuex from session in-memory inbox (no localStorage).

     * Boot path should follow with `refresh` for API truth.

     */

    hydrate({ commit }, empId) {

      const items = notificationService.list(empId)

      commit('SET_ITEMS', items)

      return items

    },



    async markRead({ commit }, { id, empId } = {}) {

      const items = await notificationService.markRead(id, empId)

      commit('SET_ITEMS', items)

      return items

    },



    async markAllRead({ commit }, empId) {

      const items = await notificationService.markAllRead(empId)

      commit('SET_ITEMS', items)

      return items

    },



    async clearAll({ commit }, empId) {

      const items = await notificationService.clearAll(empId)

      commit('SET_ITEMS', items)

      return items

    },



    /** Upsert FCM / session row into inbox + Vuex — no API POST (server already sent push). */
    ingestFcm({ commit }, { notification, empId, forceUnread = true } = {}) {
      if (!notification) return notificationService.list(empId)
      const items = notificationService.ingestFcm(notification, { empId, forceUnread })
      commit('SET_ITEMS', items)
      return items
    },

    /** Create / upsert one notification (session memory + optional POST). */

    async create({ commit }, { notification, empId, forceUnread } = {}) {

      if (!notification) return notificationService.list(empId)

      const items = await notificationService.create(notification, { empId, forceUnread })

      commit('SET_ITEMS', items)

      commit('SET_API_AVAILABLE', notificationService.apiAvailable)

      return items

    },

  },

}


